var React = require('react');

function Wave (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.125 5.62497C3.125 5.62497 6.25 3.12497 10 5.62497C13.75 8.12497 16.875 5.62497 16.875 5.62497","stroke":"#22202F","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M3.125 9.99997C3.125 9.99997 6.25 7.49997 10 9.99997C13.75 12.5 16.875 9.99997 16.875 9.99997","stroke":"#22202F","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M3.125 14.375C3.125 14.375 6.25 11.875 10 14.375C13.75 16.875 16.875 14.375 16.875 14.375","stroke":"#22202F","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Wave.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Wave;

Wave.default = Wave;
